import { ILang, Medium } from "./types";

// Error Response Code Enum
export enum ErrorResponseCode {
  GENERAL_ERROR = "GENERAL_ERROR",
  TIMEOUT = "TIMEOUT",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  NOT_FOUND = "NOT_FOUND",
  // Add other error codes as needed
}
export enum ROUTES {
  Home = "/",
}
export enum TEXT_TAGS {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  SPAN = "span",
  P = "p",
}
export enum IDS {
  WELCOME_TEXT = "welcome-text",
}
export enum INPUT_LENGTH {
  ID = 9,
  PHONE = 10,
  OTP = 6,
  ZIP = 7,
}

export interface MobileOtp {
  personalId: string;
  medium?: Medium;
  phone?: string;
  email?: string;
  locale?: ILang;
}
export interface ValidateOtpInput {
  personalId: string;
  otp: string;
  session?: string;
}
export enum API_RESULT {
  IDLE = "idle",
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}
export enum AFFILIATE_TYPES {
  HOTELS = "hotels",
  FLIGHTS = "flights",
  ATTRACTIONS = "attractions",
}

export enum ERROR_MESSAGES {
  USER_NOT_FOUND = "UserNotFoundException",
  OTP_INVALID = "OTP_INVALID",
  USER_BLOCKED = "USER_BLOCKED",
  NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException",
  // Add other error messages as needed
}

export enum ERROR_TYPE {
  USER_NOT_FOUND = "USER_NOT_FOUND",
  OTP_INVALID = "OTP_INVALID",
  USER_BLOCKED = "USER_BLOCKED",
  GENERAL = "GENERAL",
}
export enum ERROR_DIRECTION {
  LEFT = "left",
  RIGHT = "right",
  CENTER = "center",
}

export enum OTP_RESPONSE_TYPE {
  CUSTOM_CHALLENGE = "CUSTOM_CHALLENGE",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
export enum CHECK_TS_ELIGIBILITY_RESPONSE_CODE {
  TERMS_NOT_ACCEPTED = 1, // לקוח לא אישר תנאי שימוש
  NO_ACTIVE_CARD = 2, // ללקוח אין כרטיס אקטיבי
  DEBT_FAILURE = 3, // כישלון בעקבות חוב
  BLACKLIST_AML_FAILURE = 4, // כישלון בעקבות רשימה שחורה / AML
  USAGE_LIMIT_FAILURE = 5, // כישלון בעקבות מגבלת שימוש
  INSUFFICIENT_BALANCE_FAILURE = 6, // כישלון בעקבות שאין מספיק יתרה ללקוח
  INVALID_PRIVATE_CARD_FAILURE = 7, // כישלון בעקבות כרטיס פרטי לא תקין
  SERVICE_UNAVAILABLE_CONTACT_SUPPORT = 8, // ללקוח אין כרטיס PC מוצמד
  VISA_CARD_FAILURE = 9, // לקוח עם כרטיס ויזה
}
export enum EVENT_SCREEN {
  MAIN = "Main",
  LOGIN = "Login",
  FLIGHTS = "Flights",
  HOTELS_AND_ATTRACTIONS = "Hotels and Attractions",
}
export enum EVENT_NAME {
  Login = "login",
  Logout = "logout",
  OTP_VERIFICATION_STARTED = "otp_verification_started",
  OTP_VERIFICATION = "otp_verification",
  OTP_VERIFICATION_FAILED = "otp_verification_failed",
  GROUP_MAIL_APPROVAL = "group_mail_approval",
  AFFILIATE_CLICK = "affiliate_click",
  LINK_CLICK = "link_click",
  FLIGHT_SEARCH = "flight_search",
  FLIGHT_SUPPLIER_CLICK = "flight_supplier_click",
  CVV_VALIDATION = "cvv_validation",
  ELIGIBILITY_CHECK = "eligibility_check",
  EXTEND_AFFILIATE_CLICK = "extend_affiliate_click",

}
export enum AUTH_METHOD {
  SMS = "sms",
  EMAIL = "email"
}